import React, { ReactElement, useEffect } from 'react';

import { getCookieByName } from './utils/utils';

import './HubspotForm.css';

declare const window: Window &
  typeof globalThis & {
    hbspt: any;
  };

interface Props {
  formId: string;
  loadingID?: string;
}

/**
 * This component also exists in storyblocks-shell. The two should be kept in sync
 * until shared-components goes away.
 */
//TODO update this with some of the npm package conventions from Hubspot-react
const HubspotForm = ({
  formId,
  loadingID = 'hubspot-form',
}: Props): ReactElement => {
  function handleHubspotFormReady(event) {
    if (event.data.type === 'hsFormCallback') {
      if (event.data.eventName === 'onFormReady') {
        const visitorIdInput: HTMLInputElement = document.querySelector(
          `#hsForm_${formId} input[name="vid"]`
        );
        if (visitorIdInput) {
          const visitorIdCookie = getCookieByName('VID');
          visitorIdInput.value = visitorIdCookie || '';
        }
      }
    }
  }

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    const setUtmValue = (form: any, utmParam: string) => {
      try {
        const utmInput = form.querySelector(`input[name='${utmParam}']`);
        utmInput.value = getCookieByName(utmParam);
      } catch (_) {
        // Fail silently
      }
    };

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '885790',
          formId,
          target: '#' + loadingID,
          css: '',
          cssClass: 'hubspot-class',
          onFormReady: function (form) {
            // https://videoblocks.atlassian.net/browse/TR-360 defines the utm params we care about.
            // Roughly in sync with StockBlocks/CoreSites/Common/Framework/Tracking/CampaignTrackingUrlParams.php
            setUtmValue(form, 'utm_source');
            setUtmValue(form, 'utm_medium');
            setUtmValue(form, 'utm_campaign');
            setUtmValue(form, 'utm_term');
            setUtmValue(form, 'utm_content');
            setUtmValue(form, 'utm_adgroup');
          },
        });
      }
    });

    window.addEventListener('message', handleHubspotFormReady);
    return () => {
      window.removeEventListener('message', handleHubspotFormReady);
    };
  }, []);

  return (
    <div>
      <div className="-mt-32 pt-32" id={loadingID}></div>
    </div>
  );
};

export default HubspotForm;
